import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '@/App';
import { ArrowLeft, User, MapPin, LogOut, Heart, Package, Settings, Bike } from 'lucide-react';
import { Button } from '@/components/ui/button';
import BottomNav from '@/components/BottomNav';

const ProfilePage = () => {
  const navigate = useNavigate();
  const { user, logout, login } = useContext(UserContext);

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-cyan-50">
        <div className="text-center"><h2 className="text-xl font-semibold text-gray-600 mb-4">Please login to view profile</h2><Button onClick={login} className="btn-primary text-white px-8 py-3 rounded-full">Login with Google</Button></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pb-20">
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center gap-3">
            <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full"><ArrowLeft className="w-6 h-6" /></button>
            <h1 className="text-2xl font-bold">My Profile</h1>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-6">
          <div className="flex items-center gap-6 mb-8">
            {user.picture ? (
              <img src={user.picture} alt={user.name} className="w-20 h-20 rounded-full" />
            ) : (
              <div className="w-20 h-20 bg-gradient-to-br from-blue-400 to-cyan-500 rounded-full flex items-center justify-center"><User className="w-10 h-10 text-white" /></div>
            )}
            <div><h2 className="text-2xl font-bold mb-1">{user.name}</h2><p className="text-gray-600">{user.email}</p></div>
          </div>
          <div className="space-y-4">
            <div className="border-b pb-4"><h3 className="font-semibold text-gray-700 mb-2 flex items-center gap-2"><MapPin className="w-5 h-5" />Saved Addresses</h3>{user.addresses && user.addresses.length > 0 ? <div className="space-y-2">{user.addresses.map((addr, idx) => <div key={idx} className="text-sm text-gray-600 bg-gray-50 p-3 rounded-lg">{addr.address}</div>)}</div> : <p className="text-sm text-gray-500">No addresses saved yet</p>}</div>
            <div className="pt-2"><Button onClick={() => { logout(); }} className="w-full bg-red-500 hover:bg-red-600 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2"><LogOut className="w-5 h-5" />Logout</Button></div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <button onClick={() => navigate('/orders')} className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow"><Package className="w-8 h-8 mx-auto text-blue-600 mb-2" /><p className="font-semibold">My Orders</p></button>
          <button onClick={() => navigate('/favorites')} className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow"><Heart className="w-8 h-8 mx-auto text-red-500 mb-2" /><p className="font-semibold">Favorites</p></button>
        </div>
        <div className="mt-4">
          <button onClick={() => navigate('/admin')} className="w-full bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow"><Settings className="w-8 h-8 mx-auto text-gray-700 mb-2" /><p className="font-semibold">Admin Dashboard</p></button>
        </div>
        <div className="mt-4">
          <button onClick={() => navigate('/delivery-partner/register')} className="w-full bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow"><Bike className="w-8 h-8 mx-auto text-green-600 mb-2" /><p className="font-semibold">Become Delivery Partner</p></button>
        </div>
        <div className="mt-4 bg-white rounded-xl shadow-md p-6">
          <h3 className="font-semibold text-gray-800 mb-4">Customer Support</h3>
          <div className="space-y-3">
            <div>
              <p className="text-sm text-gray-500">Email Support (24/7)</p>
              <a href="mailto:foodmatrixenquiry@gmail.com" className="text-green-600 font-medium hover:underline">foodmatrixenquiry@gmail.com</a>
            </div>
            <div>
              <p className="text-sm text-gray-500">Call us: Mon–Fri, 10 AM – 4 PM</p>
              <a href="tel:+917620715987" className="text-green-600 font-medium hover:underline">7620715987</a>
            </div>
          </div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
};

export default ProfilePage;
